import { XSELL_BANNER_CLOSE_MODE_THREE_PERIOD } from '@/constants';
import { ClosedXSellBannerState, XsellBannerCloseMode } from '@/types';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { isEmmaApp } from '@axa-asia/utils';

export const getClosedXsellBannerFromStorage: () => Promise<{
  closedXsellBannerCustState: ClosedXSellBannerState[];
  closedXsellBannerLocalState: ClosedXSellBannerState[];
}> = async () => {
  let closedXsellBannerFromCustState: ClosedXSellBannerState[] = [];
  let closedXsellBannerFromLocalState: ClosedXSellBannerState[] = [];

  const emmaJS = await EmmaFactory.createInstance();

  try {
    let storageValue: ClosedXSellBannerState[];

    if (isEmmaApp) {
      storageValue = ((await emmaJS?.instance.getCacheValue(
        'closedXsellBannerFromCustState',
      )) || []) as ClosedXSellBannerState[];
    } else {
      const value = localStorage.getItem('closedXsellBannerFromCustState');
      storageValue = value ? JSON.parse(value) : [];
    }

    closedXsellBannerFromCustState = storageValue.filter((item) => {
      if (item.closeMode === XsellBannerCloseMode['72_HOURS']) {
        const closedTime = new Date(item.closedAt || '');
        const currentTime = new Date();
        if (
          currentTime.getTime() - closedTime.getTime() >
          XSELL_BANNER_CLOSE_MODE_THREE_PERIOD
        ) {
          /**
           * now - close time > 72 hours mean expired so return empty no store in redux
           */
          return false;
        }
      }
      return true;
    });

    // Filter out expired 72 hours closed banners and update storage
    if (isEmmaApp) {
      emmaJS.instance.setCacheValue(
        'closedXsellBannerFromCustState',
        closedXsellBannerFromCustState,
      );
    } else {
      localStorage.setItem(
        'closedXsellBannerFromCustState',
        JSON.stringify(closedXsellBannerFromCustState),
      );
    }
  } catch (err) {
    console.error('Error fetching closedXsellBannerFromLocalState:', err);
  }

  try {
    let storageValue: ClosedXSellBannerState[] = [];
    if (isEmmaApp) {
      storageValue = ((await emmaJS?.instance.getCacheValue(
        'closedXsellBannerFromLocalState',
      )) || []) as ClosedXSellBannerState[];
    } else {
      const value = localStorage.getItem('closedXsellBannerFromLocalState');
      storageValue = value ? JSON.parse(value) : [];
    }
    closedXsellBannerFromLocalState = storageValue;
  } catch (err) {
    console.error('Error fetching closedXsellBanner:', err);
  }

  return {
    closedXsellBannerCustState: closedXsellBannerFromCustState,
    closedXsellBannerLocalState: closedXsellBannerFromLocalState,
  };
};

export const updateClosedXsellBannerToStorage = async (
  closedEventXsellBanner: ClosedXSellBannerState[],
  type: 'closedXsellBannerFromCustState' | 'closedXsellBannerFromLocalState',
) => {
  const emmaJS = await EmmaFactory.createInstance();
  if (isEmmaApp) {
    emmaJS?.instance.setCacheValue(type, closedEventXsellBanner, true);
  } else {
    localStorage.setItem(type, JSON.stringify(closedEventXsellBanner));
  }
};
